import { jsx, jsxs } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { useModelCompareTranslation } from '../../../../../constants/modelCompareData/translations/useModelCompareTranslation.mjs';
import { ProductGroups as ProductGroups$1, ProductGroupLabelContainer, ProductGroupLabel, ProductGroupLabelLineContainer, ProductGroupLabelGrayLine, ProductGroupLabelLine } from '../../ProductList.styles.mjs';
import { groupProducts } from './groupProducts.mjs';
"use strict";
const ProductGroups = ({
  products,
  activeGroup,
  playAnimation,
  canPlayAniimation,
  showProductGroups
}) => {
  const groupedGroups = useMemo(() => groupProducts(products), [products]);
  const {
    formatMessage
  } = useModelCompareTranslation();
  return /* @__PURE__ */jsx(ProductGroups$1, {
    $columns: products.length,
    children: groupedGroups.map(({
      productListGroup,
      span
    }) => {
      const isActive = canPlayAniimation && playAnimation && activeGroup === productListGroup?.id;
      return productListGroup ? /* @__PURE__ */jsxs(ProductGroupLabelContainer, {
        $span: span,
        children: [/* @__PURE__ */jsxs(ProductGroupLabel, {
          id: productListGroup.id,
          $isActive: isActive,
          $productGroupsSelectorExists: showProductGroups,
          children: [formatMessage(productListGroup?.title), " ", formatMessage("commons.productList.series")]
        }), /* @__PURE__ */jsx(ProductGroupLabelLineContainer, {
          children: /* @__PURE__ */jsx(ProductGroupLabelGrayLine, {
            children: /* @__PURE__ */jsx(ProductGroupLabelLine, {
              $isActive: isActive,
              $playAnimation: playAnimation,
              $productGroupsSelectorExists: showProductGroups
            })
          })
        })]
      }, productListGroup.id) : null;
    })
  });
};
export { ProductGroups };
//# sourceMappingURL=ProductGroups.mjs.map
